import {LoggerProvider, SimpleLogRecordProcessor} from '@opentelemetry/sdk-logs';
import {joinUrl} from "../Utilities/UriUtilities";
import {HttpLogExporter} from "./HttpLogExporter";

const salesPortalApiDomain = window._env_ && window._env_.REACT_APP_SALES_PORTAL_API_DOMAIN ?
    window._env_.REACT_APP_SALES_PORTAL_API_DOMAIN : process.env.REACT_APP_SALES_PORTAL_API_DOMAIN

const exporter = new HttpLogExporter(joinUrl(salesPortalApiDomain ?? "", "/metrics/opentelemetry/counter"));
const logRecordProcessor = new SimpleLogRecordProcessor(exporter)
const loggerProvider = new LoggerProvider({
    resource: undefined,
    processors: [logRecordProcessor]
});

export const COUNTER_PAGE_LOAD = loggerProvider.getLogger('salesportal.webapp.page_load');
export const COUNTER_API_CALLS = loggerProvider.getLogger('salesportal.webapp.api_calls');
